// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ContentWrapper{--layout-width: var(--container-large);max-width:calc( var(--layout-width) + (2 * var(--layout-lateral)));padding-left:var(--layout-lateral);padding-right:var(--layout-lateral);margin:0 auto}\n", ""]);
// Exports
module.exports = exports;
